import React from 'react';

export const EmailSVG: React.FC<{
	className?: string;
	title?: string;
}> = ({ className, title }) => {
	return (
		<svg
			width="48"
			height="48"
			viewBox="0 0 69 51"
			fill="none"
			className={className}
			xmlns="http://www.w3.org/2000/svg">
			<title>{title}</title>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M65 1.1C65 1.1 64.9 1.1 64.9 1H64.8C64.5 0.8 64.2 0.6 63.9 0.5C63.8 0.5 63.7 0.4 63.6 0.4C63.5 0.4 63.5 0.4 63.4 0.3C63.3 0.3 63.3 0.3 63.2 0.2C63 0.1 62.8 0.1 62.7 0C62.2 0 61.8 0 61.3 0H6.8C6.4 0 5.9 0 5.5 0.1C5.3 0.1 5.1 0.2 5 0.3C4.9 0.3 4.9 0.3 4.8 0.4C4.7 0.4 4.7 0.4 4.6 0.5C4.5 0.5 4.4 0.6 4.3 0.6C3.9 0.7 3.6 0.8 3.3 1H3.2C3.2 1 3.1 1 3.1 1.1C1.2 2.4 0 4.5 0 6.9V43.8C0 45.7 0.7 47.4 2.1 48.8C3.4 50.1 5.1 50.8 6.8 50.8H61.3C63.1 50.8 64.7 50.1 66 48.8C67.3 47.5 68.1 45.7 68.1 43.8V6.9C68.1 4.5 66.9 2.4 65 1.1ZM6 3.4C6.3 3.3 6.6 3.3 6.8 3.3H61.3C61.6 3.3 61.9 3.3 62.1 3.4L36.4 27.7C35.1 28.9 33 28.9 31.7 27.7L6 3.4C5.9 3.4 5.9 3.4 6 3.4C5.9 3.4 6 3.4 6 3.4ZM3.2 6.9V43.8C3.2 44.2 3.3 44.7 3.4 45.1L24.4 25.4L3.5 5.6C3.3 6 3.2 6.5 3.2 6.9ZM61.3 47.4H6.8C6.5 47.4 6.2 47.4 5.9 47.3L26.9 27.6L29.6 30.1C30.9 31.2 32.5 31.8 34.1 31.8C35.7 31.8 37.3 31.2 38.6 30.1L41.3 27.6L62.3 47.3C61.9 47.4 61.6 47.4 61.3 47.4ZM64.6 45.1C64.8 44.7 64.8 44.3 64.8 43.8V6.9C64.8 6.4 64.7 6 64.6 5.6L43.6 25.3L64.6 45.1Z"
			/>
		</svg>
	);
};
